import type { GraphSidePanelData } from 'components/Graph/GraphSidePanelData';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { shouldShowLeavingDialog } from '../helpers/shouldShowLeavingDialog';
import { showLeavingDialog } from './showLeavingDialog';

export interface PerformLeavingActionCommand {
  callback: () => void;
  nextSidePanelState?: GraphSidePanelData;
}

export const performLeavingAction: GraphCommandFactory<
  PerformLeavingActionCommand
> = (cmdContext, dispatch) => (command) => {
  if (
    shouldShowLeavingDialog(cmdContext.getState(), command.nextSidePanelState)
  ) {
    dispatch(showLeavingDialog, { continueCallback: command.callback });
  } else {
    command.callback();
  }
};
